import { styled, Box } from "@mui/material";

export const OptionsContentWrapper = styled(Box)(({ theme, row }) => ({
  // margin: "auto",
  zIndex: 2,
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  overflowX: "auto",
  gap: "2.5rem",
  boxSizing: "border-box",
  padding: "0rem 2rem",
  flexWrap: "no-wrap",
  width: "auto",
  maxWidth: "100%",
  paddingBottom: 10,
  overflowY: "hidden",
  [theme.breakpoints.down("lg")]: {
    padding: "0.5rem 1rem 0.75rem",
    marginBottom: 5,
  },
  [theme.breakpoints.down("md")]: {
    width: "auto",
    padding: "0.5rem 1rem 0.75rem",
    gap: "1.5rem",
  },
  "&::-webkit-scrollbar-track": {
    marginRight: "2rem",
    marginLeft: "2rem",
  },
}));
